if (!window.customProductCardScriptLoaded) {
  window.customProductCardScriptLoaded = true;

  document.addEventListener('submit', function(e) {
    if (e.target.matches('.add-to-cart-form')) {
      e.preventDefault();
      const form = e.target;
      const btn = form.querySelector('.add-to-cart-btn');
      const originalText = btn.textContent.trim();
      const formData = new FormData(form);

      btn.textContent = 'Agregando...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => {
        if (!response.ok) throw new Error('Error al agregar');
        return response.json(); // Ítem agregado
      })
      .then(() => {
        // Solicitamos el carrito completo para obtener el conteo de ítems
        return fetch('/cart.js').then(res => res.json());
      })
      .then(cartData => {
        btn.textContent = '¡Agregado!';
        
        // Disparamos el evento nativo "ThemeEvents.cartUpdate" que tu tema está escuchando
        const event = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartData,
            sourceId: 'custom-product-card',
            data: {
              itemCount: cartData.item_count,
              source: 'custom-product-card'
            }
          }
        });
        document.dispatchEvent(event);

        setTimeout(() => {
          btn.textContent = 'Agregar al carrito';
          btn.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    }
  });
}